import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { AuthenticationService, Globals, User } from "../../shared";
import { MatSnackBar } from "@angular/material";

declare let mLayout: any;
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "app-aside-nav",
  templateUrl: "./aside-nav.component.html",
})
export class AsideNavComponent implements OnInit, AfterViewInit {
  public user: User;

  constructor(
    private authService: AuthenticationService,
    private snackBar: MatSnackBar,
    public globals: Globals
  ) {}
  public ngOnInit() {
    this.user = this.authService.getCurrentUserCookie();
  }
  public ngAfterViewInit() {
    mLayout.initAside();
    const menu = ($("#m_aside_left") as any).mMenu();
    const item = $(menu)
      .find('a[href="' + window.location.pathname + '"]')
      .parent(".m-menu__item");
    $(menu).data("menu").setActiveItem(item);

    setTimeout(() => {
      if (this.globals.frontendRefresh) {
        this.snackBar.openFromComponent(FrontendUpdateBar, {
          duration: 60 * 60 * 1000,
        });
      }
    }, 3000);
  }
}

@Component({
  selector: "frontend-update-bar",
  template: `
    <b class="update">New updates available. Please click here to update</b>
    <button
      mat-mini-fab
      class="clickable"
      color="success"
      (click)="hardRefresh()"
    >
      <mat-icon>system_update</mat-icon>
    </button>
  `,
  styles: [
    `
      .update {
        color: #94a3ec;
        padding-right: 20px;
      }
    `,
  ],
})
export class FrontendUpdateBar {
  public hardRefresh() {
    const updateCache = JSON.parse(localStorage.getItem("updateCache"));
    if (updateCache) {
      updateCache.updating = false;
      localStorage.setItem("updateCache", JSON.stringify(updateCache));
    }
    window.location.reload(true);
  }
}
